<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/zhaoshang/customer' }">客户管理</el-breadcrumb-item>
      <el-breadcrumb-item>合同解约</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区 -->
    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span class="cardHeader">合同解约</span>
      </div>

      <el-form :model="form" ref="formRef" :rules="formRules" label-width="120px" :inline="false" size="normal">

        <el-row :gutter="20">
          <el-col :span="8" :offset="0">
            <!-- 客户信息 -->
            <el-form-item label="合同编号：">
              <el-input disabled :value="contractNo" placeholder="请输入合同编号" style="width: 100%"></el-input>
            </el-form-item>

            <!-- 客户信息 -->
            <el-form-item label="客户名称：">
              <el-input disabled :value="customerName" placeholder="请输入客户名称" style="width: 100%"></el-input>
            </el-form-item>

            <!-- 成交项目 -->
            <el-form-item label="成交项目：">
              <el-input disabled :value="projectName" placeholder="请输入成交项目" style="width: 100%"></el-input>
            </el-form-item>

            <!-- 合同金额 -->
            <el-form-item label="合同金额：">
              <el-input disabled :value="contractAmount" placeholder="请输入合同金额" style="width: 100%"></el-input>
            </el-form-item>

            <!-- 服务时间 -->
            <el-form-item label="服务周期：">
              <el-input disabled :value="serviceStartDate||'未填写'" placeholder="请输入服务开始时间" style="width: 43%"></el-input>
              至
              <el-input disabled :value="serviceEndDate||'未填写'" placeholder="请输入服务结束时间" style="width: 43%"></el-input>
            </el-form-item>

            <!-- 财务记录 -->
            <el-form-item label="财务记录：">
             <div v-for="(item,index) in bills" :key="item._id">

               <el-tag v-if="item.type===1" type="success" size="medium">【{{ index+1 }}】 {{ item.payDate|date }}，收{{ item.payType }}￥{{ item.totalAmount }}</el-tag>
               <el-tag v-else type="danger" size="medium">【{{ index+1 }}】 {{ item.payDate|date }}，{{ item.payType }}-￥{{ item.totalAmount }}</el-tag>
             </div>
            </el-form-item>

            <!-- 扣除管理费 -->
            <el-form-item label="扣除管理费：" prop="rescindFee">
              <el-input-number v-model="form.rescindFee" :min="0" :step="100" placeholder="请输入金额" style="width: 70%"></el-input-number>
            </el-form-item>

            <!-- 解约原因 -->
            <el-form-item label="解约原因：" prop="rescindReason">
              <el-input v-model="form.rescindReason" type="textarea" :rows="6" placeholder="请输入解约原因（选填，最多500字符）" maxlength="500"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" :loading="submitting" @click="okClickHandler">解约</el-button>
              <el-button @click="goBack">返回</el-button>
            </el-form-item>

          </el-col>
          <el-col :span="16" :offset="0">
            <!-- 收支类型 -->
            <el-form-item label="收支类型：" prop="type">
              <el-radio-group :value="-1">
                <el-radio :label="-1">退款</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 总金额 -->
            <el-form-item label="退款金额：" prop="totalAmount" style="width:50%">
              <el-input-number v-model="form.totalAmount" :min="0" :precision="2" :step="100" placeholder="请输入金额" style="width: 70%"></el-input-number>
            </el-form-item>

            <!-- 退款账户 -->
            <el-form-item label="退款账户：" prop="payAccount" style="width:50%">
              <el-select v-model="form.payAccount" placeholder="请选择退款账户" style="width: 100%">
                <el-option v-for="item in payAccountList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>

            <!-- 钱款类型 -->
            <el-form-item label="钱款类型:" prop="payType" style="width:50%">
              <el-radio-group value="退款" size="small">
                <el-radio-button v-for="item in payTypeList" :key="item" :label="item">{{ item }}</el-radio-button>
              </el-radio-group>
            </el-form-item>

            <!-- 退款日期 -->
            <el-form-item label="退款日期：" prop="payDate" style="width:50%" >
              <el-date-picker
                v-model="form.payDate"
                type="date"
                placeholder="请选择退款日期"
                style="width: 100%"
                value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>

            <!-- 退款备注 -->
            <el-form-item label="退款备注：" prop="remark" style="width:50%">
              <el-input v-model="form.remark" type="textarea" :rows="3" placeholder="请输入退款备注（选填，最多500字符）" maxlength="500"></el-input>
            </el-form-item>

            <!-- 附件上传 -->
            <el-form-item label="附件：">
              <el-upload
                :action="uploadUrl"
                :headers="uploadHeaders"
                :on-success="handleUploadSuccess"
                :on-remove="handleRemove"
                :on-preview="handlePreview"
                :before-upload="beforeUpload"
                :file-list="fileList"
                list-type="picture-card">
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">支持图片、PDF等文件格式</div>
              </el-upload>
            </el-form-item>

          </el-col>
        </el-row>

      </el-form>

    </el-card>

    <!-- PDF预览对话框 -->
    <el-dialog :visible.sync="pdfPreviewDialogVisible" width="60%" :title="previewTitle">
      <div class="preview-container" style="height: 600px;">
        <iframe :src="previewUrl" style="width: 100%; height: 100%; border: none;"></iframe>
      </div>
    </el-dialog>

    <!-- 图片预览 -->
    <el-image
      v-show="false"
      ref="imageViewer"
      :src="currentImageUrl"
      :preview-src-list="imagePreviewList">
    </el-image>

  </div>
</template>

<script>
import { payTypeList, payAccountList } from '@/utility/staticData'
export default {
  data () {
    return {
      contractNo: '', // 合同编号
      // 提交中标志位（防重复点击）
      submitting: false,
      projectName: '', // 项目名称
      customerName: '', // 客户名称
      contractAmount: 0, // 合同金额
      serviceStartDate: '', // 服务开始日期
      serviceEndDate: '', // 服务结束日期
      bills: [], // 收支单列表

      form: {
        contractId: '', // 合同ID
        rescindFee: 0, // 扣除的管理费
        rescindReason: '', // 合同备注

        payAccount: '',
        totalAmount: 0,
        payDate: '',
        attachments: [],
        remark: ''
      },

      formRules: {
        rescindReason: { required: true, message: '请输入解约原因', trigger: 'blur' },
        rescindDate: { required: true, message: '请选择退款日期', trigger: 'change' },
        remark: { required: false, message: '请输入退款备注', trigger: 'blur' },
        rescindFee: [
          { required: true, message: '请输入退款金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '退款金额不能为负数', trigger: 'blur' }
        ],
        payAccount: { required: true, message: '请选择退款账户', trigger: 'change' },
        totalAmount: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { type: 'number', min: 0, message: '金额不能为负数', trigger: 'blur' }
        ],
        payDate: { required: true, message: '请选择退款日期', trigger: 'change' }
      },

      // 列表数据
      payTypeList: payTypeList.filter(item => item === '退款'),
      payAccountList: payAccountList,

      // 当前账号信息
      accountInfo: {
        level: null,
        employeeId: '',
        employeeName: '',
        department: '',
        job: ''
      },

      // 上传使用
      uploadUrl: this.$http.defaults.baseURL + 'upload',
      uploadHeaders: {
        authorization: window.sessionStorage.getItem('token'),
        Accept: 'application/json'
      },
      fileList: [],

      // 预览相关
      pdfPreviewDialogVisible: false,
      previewUrl: '',
      previewTitle: '',
      currentImageUrl: '',
      imagePreviewList: [],

      // PDF 图标路径
      pdfIconUrl: require('@/assets/pdf.png'),

      // 用于预览的基础url
      base: ''
    }
  },
  created () {
    this.base = window.sessionStorage.getItem('base')
    this.getAccountInfo()
    this.getContractDetail()
  },
  methods: {
    // 获取当前登录账号的信息
    getAccountInfo () {
      this.accountInfo.level = parseInt(window.sessionStorage.getItem('level'))
      this.accountInfo.employeeId = window.sessionStorage.getItem('employeeId') || ''
      this.accountInfo.employeeName = window.sessionStorage.getItem('employeeName') || ''
      this.accountInfo.department = window.sessionStorage.getItem('department') || ''
      this.accountInfo.job = window.sessionStorage.getItem('job') || ''

      // 从路由参数获取客户信息
      this.form.contractId = this.$route.query.contractId
    },

    // 获取合同详情
    async getContractDetail () {
      const { data: res } = await this.$http.get(`zhaoshang/contract/detail/${this.form.contractId}`)
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }
      this.contractNo = res.data.contractNo
      this.projectName = res.data.projectName
      this.customerName = res.data.customerName
      this.contractAmount = res.data.contractAmount
      this.serviceStartDate = this.$getDateTime(new Date(res.data.serviceStartDate))
      this.serviceEndDate = this.$getDateTime(new Date(res.data.serviceEndDate))
      this.bills = res.data.bills
    },

    // 判断文件类型
    getFileType (fileName) {
      const ext = fileName.toLowerCase().split('.').pop()
      const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      const pdfExts = ['pdf']

      if (imageExts.includes(ext)) return 'image'
      if (pdfExts.includes(ext)) return 'pdf'
      return 'other'
    },

    // 上传前校验
    beforeUpload (file) {
      const fileType = this.getFileType(file.name)
      const isValidType = ['image', 'pdf'].includes(fileType)

      if (!isValidType) {
        this.$message.error('只支持上传图片或PDF文件')
        return false
      }

      const isLt50M = file.size / 1024 / 1024 < 50
      if (!isLt50M) {
        this.$message.error('文件大小不能超过 50MB!')
        return false
      }

      return true
    },

    // 上传成功
    handleUploadSuccess (res, file, fileList) {
      if (res.meta.status !== 200) {
        return this.$message.error(res.meta.msg)
      }

      const fileType = this.getFileType(file.name)
      const baseUrl = this.base

      // 为PDF文件设置自定义图标
      if (fileType === 'pdf') {
        const fileItem = fileList[fileList.length - 1]
        fileItem.url = this.pdfIconUrl // 用于显示图标
        fileItem.actualUrl = baseUrl + res.data.url // 保存实际文件地址用于预览
      }

      this.form.attachments.push({
        url: res.data.url,
        name: file.name,
        type: fileType
      })
      this.fileList = fileList
    },

    // 删除文件
    handleRemove (file, fileList) {
      const index = this.fileList.indexOf(file)
      if (index !== -1 && this.form.attachments[index]) {
        this.form.attachments.splice(index, 1)
      }
      this.fileList = fileList
    },

    // 预览文件
    handlePreview (file) {
      const attachment = this.form.attachments.find(item => item.name === file.name)
      if (!attachment) return

      const baseUrl = this.base
      const fileUrl = baseUrl + attachment.url

      console.log(fileUrl)

      this.previewTitle = file.name

      if (attachment.type === 'image') {
        // 使用 Element UI 的图片预览
        this.buildImagePreviewList()
        this.currentImageUrl = fileUrl
        this.$nextTick(() => {
          this.$refs.imageViewer.clickHandler()
        })
      } else if (attachment.type === 'pdf') {
        // PDF使用对话框预览
        this.previewUrl = file.actualUrl || fileUrl
        this.pdfPreviewDialogVisible = true
      }
    },

    // 构建图片预览列表
    buildImagePreviewList () {
      const baseUrl = this.base
      this.imagePreviewList = this.form.attachments
        .filter(item => item.type === 'image')
        .map(item => baseUrl + item.url)
    },

    // 点击添加按钮
    async okClickHandler () {
      // 防止重复点击：提交中直接拦截
      if (this.submitting) return

      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return false

        const submitData = {
          contractId: this.form.contractId,
          rescindFee: this.form.rescindFee, // 退款金额
          rescindReason: this.form.rescindReason || '', // 解约原因

          payAccount: this.form.payAccount,
          totalAmount: this.form.totalAmount,
          payDate: this.form.payDate,
          attachments: this.form.attachments,
          remark: this.form.remark || ''
        }

        try {
          await this.$confirm(
            `确认解约该合同？\n\n合同编号：${this.contractNo}\n客户名称：${this.customerName}\n退款金额：￥${this.form.totalAmount}\n扣除管理费：￥${this.form.rescindFee}`,
            '解约确认',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              dangerouslyUseHTMLString: false
            }
          )

          // 确认后进入提交中状态
          this.submitting = true
          const { data: res } = await this.$http.post('zhaoshang/customerBill/addRefund', submitData)
          if (res.meta.status !== 200) {
            this.$message.error(res.meta.msg)
            return false
          }
          this.$message.success(res.meta.msg)
          this.goBack()
        } catch (error) {
          if (error !== 'cancel') {
            console.error('添加财务记录失败:', error)
            this.$message.error('添加财务记录失败')
          }
        } finally {
          // 无论成功失败，释放提交状态
          this.submitting = false
        }
      })
    },

    // 返回
    goBack () {
      const query = { ...this.$route.query }
      delete query.contractId

      // 构建返回URL
      const queryString = Object.keys(query).length > 0
        ? '?' + Object.entries(query).map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join('&')
        : ''

      this.$router.push('/zhaoshang/customer' + queryString)
    }
  }
}
</script>

<style lang="less" scoped>
.preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

// 自定义上传列表中的PDF图标样式
::v-deep .el-upload-list__item-thumbnail {
  object-fit: contain;
}

// 图片预览样式优化
::v-deep .el-image-viewer__wrapper {
  z-index: 3000;
}
</style>
